module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "app-footer"
  }, [_vm._v("\n    © " + _vm._s(_vm.date) + " LeadGroup. \n    "), _c('span', {
    staticClass: "float-right",
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('statistic.last_version')) + ":")]), _vm._v(" "), _c('span', [_c('router-link', {
    attrs: {
      "to": '/pages/versions'
    }
  }, [_vm._v(_vm._s(_vm.lastVersion))])], 1)]), _vm._v(" "), _c('span', {
    staticClass: "float-right"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('statistic.last_update')) + ":")]), _vm._v(" "), (_vm.Storage.developMode) ? _c('span', [_c('router-link', {
    attrs: {
      "to": '/pages/changelog'
    }
  }, [_vm._v(_vm._s(_vm.lastUpdate))])], 1) : _c('span', [_vm._v(_vm._s(_vm.lastUpdate))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bc36556"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 521
// module chunks = 0